<template>
  <div class="home">
    <div class="content">
      <section class="sectionClass">
        <div class="box">
          <div class="t" style="cursor: pointer; " @click="goToHome()">MiReportor</div>
          <div class="r">
            <div class="r1" @click="showLogin">
              <!-- <el-badge
                class="item"
                style="margin-right: 40px"
                v-if="rolename != 'Administrator'"
              >
              </el-badge> -->
              <!-- <el-button type="primary" size="small" @click="exit"
                >退出登录</el-button
              > -->
              <el-menu
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
                v-if="token"
              >
                <el-submenu index="2">
                  <template slot="title"
                    ><div class="imgBox">
                      <img src="../../../static/index1.png" alt="" />
                    </div>
                    {{ userName ? userName : "未登录" }}</template
                  >
                  <!-- <el-menu-item index="2-1">修改密码</el-menu-item> -->
                  <el-menu-item index="2-2" v-if="userName" class="menu-item"
                    >退出登录</el-menu-item
                  >
                </el-submenu>
              </el-menu>
              <el-menu
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect2"
                v-else
              >
                <el-submenu index="2">
                  <template slot="title"
                    ><div class="imgBox">
                      <img src="../../../static/index1.png" alt="" />
                    </div>
                    {{ userName ? userName : "未登录" }}</template
                  >
                  <!-- <el-menu-item index="2-1">修改密码</el-menu-item> -->
                  <el-menu-item index="2-2" v-if="userName" class="menu-item"
                    >登录</el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
          </div>
        </div>
        <router-view v-if="userName" @showLogin="handleSelect2"></router-view>
      </section>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="640px"
      :before-close="handleClose"
    >
      <div class="loginClass">
        <div class="title">登录</div>
        <el-form
          class="form_right"
          ref="form"
          :rules="rules"
          :model="form"
          label-width="0"
        >
          <el-form-item label="账户" prop="account">
            <el-input
              v-model="form.account"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="form.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <div class="checkBox">
            <el-checkbox v-model="form.save">记住密码</el-checkbox>
            <!-- <div class="updete">忘记密码？</div> -->
          </div>
          <el-form-item>
            <el-button
              type="primary"
              style="background: linear-gradient(180deg, #16796F 0%, #045A51 100%);border: 1px solid #004B43;"
              @click="login('form')"
              >登录</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              style="background: linear-gradient(180deg, #FFFFFF 0%, #F9F9FB 100%);border: 1px solid #D7DCE4;"
              @click="registerVisible = true"
              >注册账号</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 注册 -->
    <el-dialog
      title=""
      :visible.sync="registerVisible"
      width="640px"
      :show-close="true"
      :before-close="handleClose"
    >
      <div class="loginClass" v-if="registerVisible">
        <div class="title">注册</div>
        <el-form
          class="form_right"
          ref="form2"
          :rules="rules"
          :model="form2"
          label-width="0"
        >
          <el-form-item label="账户" prop="account">
            <el-input
              v-model="form2.account"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="form2.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <!-- <div class="checkBox">
            <el-checkbox v-model="form.save">记住密码</el-checkbox>
            <div class="updete">忘记密码？</div>
          </div> -->
          <el-form-item>
            <el-button
              type="primary"
              style="background: linear-gradient(180deg, #16796F 0%, #045A51 100%);"
              @click="register('form2')"
              >注册</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              @click="
                (form2.password = ''),
                  (form2.account = ''),
                  (registerVisible = false)
              "
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import storage from "../../utils/storage";
export default {
  data() {
    return {
      userName: "",
      registerVisible: false,
      dialogVisible: false,
      form: {
        account: "",
        password: "",
        save: false
      },
      form2: {
        account: "",
        password: "",
        save: false
      },
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      token: localStorage.getItem("token")
    };
  },
  computed: {
    ...mapState({})
  },
  created() {},
  methods: {
    ...mapActions([]),
    handleSelect2(e) {
      if (e == "2-1") {
      } else {
        this.dialogVisible = true;
      }
    },
    handleSelect(e) {
      if (e == "2-1") {
      } else {
        this.exit();
      }
    },
    showLogin() {
      if (!localStorage.getItem("token")) {
        this.dialogVisible = true;
      }
    },
    handleClose() {
      // localStorage.setItem("token", "xxx");
      this.$router.push("/wecome");
      this.$router.go();
    },
    exit() {
      this.$confirm("确定要退出登陆吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios.get("/medicine/logout").then(res => {
            if (res.data.code == 0) {
              localStorage.removeItem("token");
              localStorage.removeItem("name");
              localStorage.removeItem("id");
              this.$message({
                message: "取消成功",
                type: "success"
              });
              this.$router.push("/");
              this.dialogVisible = true;
              this.userName = "";
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    register(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            password: this.form2.password,
            name: this.form2.account
          };
          this.$axios.post("/medicine/register", params).then(res => {
            console.log(res);
            if (res.data.code == 0) {
              this.$message({
                message: "注册成功",
                type: "success"
              });
              this.form2.password = "";
              this.form2.account = "";
              this.registerVisible = false;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }
          });
        }
      });
    },
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            password: this.form.password,
            userName: this.form.account
          };
          this.$axios.post("/medicine/login", params).then(res => {
            if (res.data.code == 0) {
              localStorage.setItem("token", res.data.data.token);
              localStorage.setItem("name", res.data.data.name);
              localStorage.setItem("id", res.data.data.id);
              this.userName = res.data.data.name;
              if (this.form.save) {
                localStorage.setItem(
                  "user",
                  JSON.stringify({
                    account: this.form.account,
                    password: this.form.password
                  })
                );
              }
              this.dialogVisible = false;
              this.form.account = "";
              this.form.password = "";
              this.form.save = false;
              this.$message({
                message: "登录成功",
                type: "success"
              });
              this.$router.replace("/index");
              this.$router.go();
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goToHome(){
        console.log("去首页")
        this.$router.push("/wecome");
        this.$router.go();
    }
  },

  mounted() {
    if (
      !localStorage.getItem("token") &&
      localStorage.getItem("pageType") != "demo"
    ) {
      this.dialogVisible = true;
      if (localStorage.getItem("user")) {
        let user = JSON.parse(localStorage.getItem("user"));
        this.account = user.account;
        this.password = user.password;
      }
    } else {
      this.userName = localStorage.getItem("name")
        ? localStorage.getItem("name")
        : "未登录";
      this.$router.replace("/index");
    }
  }
};
</script>
<style scoped>
/deep/ .el-input .el-input__inner:focus {
  border: 1px solid #045a51;
}
/deep/ .el-dialog {
  border-radius: 12px;
}
.title {
  font-family: "PingFang SC";
  font-weight: 400;
  font-size: 30px;
  color: #3f455d;
}
/deep/ .loginClass .form_right .el-form-item__label {
  float: none;
}
.loginClass .form_right .checkBox {
  width: 348px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
}
.loginClass .form_right .checkBox .updete {
  cursor: pointer;
}

.loginClass .form_right .el-button {
  width: 100%;
}
.loginClass {
  width: 348px;
  padding: 30px 0;
  margin: 0 auto;
}
.el-menu-demo {
  border: none;
}

/deep/ .el-menu-demo .el-submenu__title {
  display: flex;
  align-items: center;
  border: none !important;
}
.el-menu-demo .imgBox {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #baced7;
  text-align: center;
  line-height: 32px;
  margin-right: 10px;
}
.el-menu-demo .imgBox img {
  width: 17px;
  height: 17px;
}

.box {
  width: calc(100% - 80px);
  padding: 0 40px;
  height: 72px;
  justify-content: space-between;
  align-items: center;
  /* box-shadow: 0px 5px 5px -5px #5e5e5e; */
  display: flex;
  background: rgba(255, 255, 255, 1);
  color: #fff;
  position: fixed;
  z-index: 99;

  border-bottom: 1px solid #d7dce4;
  box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.08);
}
.box .l {
  width: 60px;
  height: 100%;
  line-height: 80px;
  font-size: 24px;
  color: black;
  padding-left: 30px;
}
.box .l i {
  cursor: pointer;
}
.box .t {
  font-family: "PingFang SC";
  font-weight: 900;
  color: #004b43;
  font-size: 19px;
}

.box .r {
  height: 100%;
  width: auto;
  display: flex;
  align-items: center;
  padding-right: 30px;
}

.box .r .r1 {
  display: flex;
  align-items: center;
  padding-right: 10px;
}
.box .r .r1 .r12 {
  color: black;
}

.box .r .r1 .r11 {
  width: 40px;
  height: 40px;
  margin-right: 3px;
}
.box .r .r1 .r11 img {
  width: 100%;
  height: 100%;
}
.box .r .r2 {
  width: 80px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid gray;
}
.box .r .r2 img {
  width: 40px;
  height: 40px;
}

.home {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.home .header {
  height: 60px;
  background: #545c64;
  display: flex;
  color: white;
  justify-content: center;
  align-items: center;
  .el-dropdown {
    font-size: 12px;
    height: 65px;
    color: white;
  }
  & > div {
    width: 50%;
    height: 100%;
    float: left;
    line-height: 60px;
    font-size: 24px;
  }
  & > div:first-of-type {
    padding-left: 50px;
  }
  & > div:last-of-type {
    text-align: right;
    padding-right: 50px;
    & > span:last-of-type {
      font-weight: 600;
    }
  }
}

.home .el-dropdown-menu .el-popper {
  top: 59px !important;
}
.home .content {
  flex: 1;
  display: flex;
  overflow: hidden;
  height: 100%;
}
.home .content .el-submenu .el-menu-item {
  min-width: 100% !important;
}
.home .content .tac {
  width: 100%;
  background: rgba(0, 233, 1, 0.1);
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
  /*justify-content: center;*/
  overflow-y: auto;
}
.home .content .tac & > div {
  height: 100% !important;
  width: 100%;
}
.home .content .tac & > div & > ul {
  height: 100% !important;
  width: 100% !important;
}
.home .content .tac::-webkit-scrollbar {
  width: 0 !important;
}
.home .content section {
  flex: 1;
}

.home .sectionClass {
  overflow: auto;
  height: 100vh;
}
.home .sectionClass .baiduQueue {
  padding-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue